module.exports = __webpack_public_path__ + "img/blue_084.f315467c.png";